import { ApplyLink, Arrow } from './ui'
import { useViewportVideo } from './useViewportVideo'
import VideoSoundControl from './VideoSoundControl'
import VideoPoster from './VideoPoster'

export default function LeadershipMessage() {
  const { error, videoProps, previewProps, controlsProps } = useViewportVideo('/images/leadership-message-poster.jpg')

  return <section className="leadership-message" id="leadership-message" aria-labelledby="leadership-message-title">
    <div className="leadership-message-copy">
      <p className="eyebrow">A MESSAGE FROM OUR LEADERSHIP</p>
      <h2 id="leadership-message-title">ฟังแนวคิด<br /><em>จากผู้นำโครงการ</em></h2>
      <p>รู้จักแนวคิดเบื้องหลัง EMPRESS OF WELLNESS<br />และคำเชิญชวนถึงผู้หญิงวัย 35+<br />ผ่านเรื่องราวจากผู้นำโครงการ</p>
      <span className="leadership-message-duration">EMPRESS OF WELLNESS <span aria-hidden="true">·</span> 1 นาที 40 วินาที</span>
      <div className="leadership-message-actions"><ApplyLink location="leadership-message" compact light /><a className="text-link" href="#competition">ดูการแข่งขันทั้ง 3 รอบ <Arrow /></a></div>
    </div>
    <figure className="leadership-film">
      <div className="leadership-film-frame">
        <video {...videoProps} width="720" height="1280" aria-label="คลิปแนวคิดและคำเชิญชวนจากผู้นำโครงการ EMPRESS OF WELLNESS">
          <source src="/videos/leadership-message.mp4" type="video/mp4" />
          เบราว์เซอร์นี้ไม่รองรับวิดีโอ <a href="/videos/leadership-message.mp4">เปิดคลิปผู้นำโครงการ</a>
        </video>
        <VideoPoster {...previewProps} />
      </div>
      <VideoSoundControl {...controlsProps} />
      <figcaption><span>ชมคลิปผู้นำโครงการ <small>01:40</small></span><a href="/videos/leadership-message.mp4" target="_blank" rel="noopener noreferrer" aria-label="เปิดคลิปผู้นำโครงการในแท็บใหม่"><Arrow /></a></figcaption>
      {error && <p className="leadership-film-error" role="alert">ยังไม่สามารถเล่นวิดีโอได้ ลองกดเล่นจากแถบควบคุม หรือ <a href="/videos/leadership-message.mp4" target="_blank" rel="noopener noreferrer">เปิดวิดีโอโดยตรง</a></p>}
    </figure>
  </section>
}
